import { render, staticRenderFns } from "./WorkType.vue?vue&type=template&id=11dc8d5a&"
import script from "./WorkType.vue?vue&type=script&lang=js&"
export * from "./WorkType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports